// extracted by mini-css-extract-plugin
module.exports = {"guide":"EnterInquiry_guide__YMC9Q","intro":"EnterInquiry_intro__vurIT","intro_1":"EnterInquiry_intro_1__20cFq"};